namespace gotoAndPlay {

    export class PostLoaderBlog {

        target: JQuery;
        ajax;

        constructor(target: JQuery) {
            this.target = target;
            this.init();
        }

        init(): void {
            $('#main_posts_load').on('click', this.loadPosts.bind(this));
        }

        loadPosts(): void {
            let then = this;
            let loaded = this.target.find('input').val();
            this.ajax = $.post(ajaxPath, {
                data: {
                    imageSize: '600x400',
                    element: 'blog_list_container',
                    skip: loaded,
                    posts: $('#posts_nr').val(),
                },
                action: 'load-posts',
            });
            this.ajax.then((result) => {
                then.target.find('input').val(Number(then.target.find('input').val()) + Number($('#posts_nr').val()));
                if (result.end) {
                    $('#main_posts_load').remove();
                }
                jQuery(result.data).appendTo(then.target);
            });
        }

    }

    $(document).ready(function() {
        let $myDiv = $('#blog_list_container');
        if ( $myDiv.length > 0) {
            let perClickOpen = $('#posts_nr').val();
            $myDiv.find('input').val(perClickOpen);
            let postloader = new PostLoaderBlog($myDiv);
        }
    });
}